module.exports = __webpack_public_path__ + "static/img/Rectangle1.4de07f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle1.png
// module id = XmGa
// module chunks = 1